import React , {useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Arrow_icon_right from "../../Assets/Icons/Arrow_Small_Right.svg";
import { Breadcrumbs, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { fetchData } from "../../Assets/API/apiservices";
import {ORGANIZATION_ID, SUB_ORGANIZATION_ID} from '../../Config/Config.js';

const NAACComponent = () => {
  const [naacData, setNaacData ] = useState([])
  const navigate = useNavigate();

  useEffect(() => {
    getNaacDetailsData();
  }, []); // eslint-disable-line

  const orgId = parseInt(ORGANIZATION_ID, 10) || 10;
const subOrgId = parseInt(SUB_ORGANIZATION_ID, 10) || 12;


  const getNaacDetailsData = async () => {
      try {
        const result = await fetchData(`naacdetails?organization_id=${orgId}&sub_organization_id=${subOrgId}`);
        return setNaacData(result)
      } catch (err) {
        toast.error(err.message);
      }
    };


  const navigation_url = (path) => {
    if (!path.path_url) {
      navigate(path.internal_path);
    } else {
      navigate("/naac/" + path.external_id + "/" + path.path_name, {
        state: { selectedDocData: path },
      });
    }
  };
  return (
    <section className="container py-5">
      <Breadcrumbs
        separator="›"
        sx={{ width: '100%', display: 'block', marginBottom: '10px' }}
        aria-label="breadcrumb"
      >
        <Link underline="hover" color="inherit" to="/">
          <b>Home</b>
        </Link>
        <Typography underline="hover" color="text.primary">
          <b>NAAC</b>
        </Typography>
      </Breadcrumbs>
      <div className="mb-4">
        <Typography variant="h4">NAAC Details</Typography>
      </div>

      <div>
        {naacData.rows &&
          naacData.rows.map((items, index) => (
            <div className="d-flex mb-3" key={index}>
              <img
                src={Arrow_icon_right}
                loading="lazy"
                placeholder="blur"
                alt="Arrow Icon"
              />
              <Typography
                variant="subtitle1"
                className="m-0 cursor-pointer"
                onClick={() => {
                  if (items.path_url !== null || items.internal_path !== null) {
                    navigation_url(items)
                  }
                }}
                style={{
                  cursor:
                    items.path_url === null || items.internal_path === null
                      ? 'not-allowed'
                      : 'pointer',
                  color:
                    items.path_url === null || items.internal_path === null
                      ? 'gray'
                      : 'inherit',
                }}
              >
                {items.title}
              </Typography>
            </div>
          ))}
      </div>
    </section>
  )
};

export default NAACComponent;
